import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {Subscription} from "rxjs/Subscription";

@Directive({
  selector: '[vbAsyncButton]',
  exportAs: 'vbAsyncButton'
})
export class AsyncButtonDirective implements OnChanges, OnDestroy {

  @Input('vbAsyncButton')
  private observable: Observable<any>;

  private sub: Subscription;

  private _isLoading: boolean = false;

  private nativeElement: HTMLElement;
  private wrapperElement: HTMLElement;
  private loadingElement: HTMLElement;

  private get isLoading(): boolean {
    return this._isLoading;
  }

  private set isLoading(value: boolean) {
    this._isLoading = value;

    this.setDisabledState(value);

    if (value == true) {
      this.wrapInDiv();
      this.addLoadingIcon();
    } else {
      this.removeLoadingElement();
      this.unwrapFromDiv();
    }

  }

  @HostListener('click', ['$event'])
  onClick() {

    this.cd.detectChanges();

    if (!this.observable) {
      console.info("No obs");
      return;
    }

    if (this.isLoading || this.isDisabled()) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    } else {
      this.startAsyncOperation();
    }

  }

  constructor(private el: ElementRef, private renderer: Renderer2, private cd: ChangeDetectorRef) {
    this.nativeElement = el.nativeElement;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.observable) {
      this.setObservable();
    }
  }

  startAsyncOperation() {
    this.isLoading = true;
  }

  finishAsyncOperation() {
    this.isLoading = false;
  }

  failAsyncOperation() {
    this.isLoading = false;
  }

  private setObservable(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.observable) {
      this.sub = this.observable.subscribe(
        res => this.finishAsyncOperation(),
        err => this.failAsyncOperation()
      );
    }
  }

  private setDisabledState(state: boolean) {
    if (state == true) {
      if (this.nativeElement instanceof HTMLButtonElement) {
        this.renderer.setProperty(this.nativeElement, 'disabled', true);
      } else {
        this.renderer.addClass(this.nativeElement, 'disabled');
      }
    } else {
      if (this.nativeElement instanceof HTMLButtonElement) {
        this.renderer.setProperty(this.nativeElement, 'disabled', false);
      } else {
        this.renderer.removeClass(this.nativeElement, 'disabled');
      }
    }
  }

  private isDisabled(): boolean {
    return this.nativeElement.classList.contains('disabled') || this.nativeElement.hasAttribute('disabled');
  }

  private wrapInDiv() {

    if (this.wrapperElement) {
      return;
    }

    // Get parent of the original input element
    let parent = this.nativeElement.parentNode;

    // Create a div
    let divElement = this.renderer.createElement("span");

    // Add class to div
    this.renderer.addClass(divElement, "inner-addon");
    this.renderer.addClass(divElement, "right-addon");

    // Add the div, just before the input
    this.renderer.insertBefore(parent, divElement, this.nativeElement);

    // Remove the input
    this.renderer.removeChild(parent, this.nativeElement);

    // Remove the directive attribute (not really necessary, but just to be clean)
    //this.renderer.removeAttribute(this.el.nativeElement, "inputWrapper");

    // Re-add it inside the div
    this.renderer.appendChild(divElement, this.nativeElement);

    this.wrapperElement = divElement;

  }

  private addLoadingIcon() {

    if (this.loadingElement) {
      return;
    }

    // Add loading icon
    let span = this.renderer.createElement('span');
    this.renderer.addClass(span, 'icon');
    this.renderer.addClass(span, 'fas');
    this.renderer.addClass(span, 'fa-spinner');
    this.renderer.addClass(span, 'fa-spin');
    this.renderer.insertBefore(this.nativeElement.parentNode, span, this.nativeElement);

    this.loadingElement = span;

  }

  private unwrapFromDiv() {

    if (!this.wrapperElement) {
      return;
    }

    let parent = this.wrapperElement.parentNode;
    this.renderer.removeChild(this.wrapperElement, this.nativeElement);
    this.renderer.insertBefore(parent, this.nativeElement, this.wrapperElement);
    this.renderer.removeChild(parent, this.wrapperElement);
    this.wrapperElement = null;

  }

  private removeLoadingElement() {

    if (!this.wrapperElement || !this.loadingElement) {
      return;
    }

    this.renderer.removeChild(this.wrapperElement, this.loadingElement);
    this.loadingElement = null;

  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/directives/async-button.directive.ts